import { LocalclassificationType, LocalclassificationStateReducer, SET_CLASSIFICATION } from './types';

const INITIAL_STATE: LocalclassificationStateReducer = {
  data: [],
};

const localClassificationReducer = (state = INITIAL_STATE, action: LocalclassificationType) => {
  switch (action.type) {
    case SET_CLASSIFICATION:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
export default localClassificationReducer;
